// extracted by mini-css-extract-plugin
export var redoItem = "_ip-1";
export var redoTrigger = "_ip-0";